import { SearchEntry } from "@/mocks/searchIndex";

export const searchIndexFr: SearchEntry[] = [
  // ── Page d'accueil ──
  {
    title: "À propos de la Caisse",
    type: "Page",
    snippet: "La Caisse de retraite des musiciens du Canada administre des prestations de retraite pour les membres et bénéficiaires admissibles partout au Canada. La Caisse est régie par un conseil de fiduciaires et soutenue par le Bureau de la Caisse.",
    href: "/fr#about",
  },
  {
    title: "Gouvernance de la Caisse",
    type: "Page",
    snippet: "La Caisse est régie par un conseil de fiduciaires comprenant la présidente, le vice-président et les fiduciaires. La mission est d'administrer le régime de manière prudente afin d'assurer la viabilité à long terme et les meilleures prestations de retraite possible.",
    href: "/fr#about",
  },
  {
    title: "Résumé du régime",
    type: "Page",
    snippet: "Un guide en langage clair décrivant les dispositions clés de la Caisse de retraite des musiciens du Canada, y compris l'admissibilité, les cotisations, le calcul des prestations, les options de retraite et les règles de distribution.",
    href: "/fr#summary-plan",
  },
  {
    title: "Régime de retraite interentreprises",
    type: "Page",
    snippet: "La Caisse de retraite des musiciens du Canada est un régime de retraite interentreprises destiné aux musiciens et autres membres admissibles. Il est financé par les cotisations des employeurs versées en vertu des ententes applicables et administré par un conseil de fiduciaires.",
    href: "/fr#summary-plan",
  },
  {
    title: "Cotisations des employeurs",
    type: "Page",
    snippet: "Les cotisations des employés ne sont ni requises ni permises. Les employeurs cotisent à la Caisse au nom des membres admissibles, et ces cotisations sont détenues en fiducie pour verser les prestations et payer les dépenses administratives de la Caisse.",
    href: "/fr#summary-plan",
  },
  {
    title: "Aperçu des prestations de retraite",
    type: "Page",
    snippet: "Le régime prévoit des prestations de retraite normales, anticipées, différées, de retraite spéciale, d'invalidité et de survivant. Les prestations de retraite ne sont pas automatiques; les membres doivent présenter une demande et soumettre les formulaires requis.",
    href: "/fr#summary-plan",
  },
  {
    title: "Résumé du régime 2019",
    type: "Resource",
    snippet: "Guide en langage clair du régime et de ses principales dispositions. Un document complet expliquant le fonctionnement du régime de retraite, y compris les règles d'admissibilité et de prestations.",
    href: "/fr#summary-plan",
  },
  {
    title: "Règles du régime",
    type: "Page",
    snippet: "Les documents constitutifs officiels de la Caisse de retraite des musiciens du Canada. Ils énoncent les conditions juridiques, les critères d'admissibilité, les dispositions relatives aux prestations et les procédures administratives qui régissent le fonctionnement de la Caisse.",
    href: "/fr#plan-rules",
  },
  {
    title: "Règles et règlements du régime",
    type: "Resource",
    snippet: "Le texte du régime mis à jour au 1er janvier 2018. Il s'agit du principal document juridique régissant la Caisse de retraite des musiciens du Canada, couvrant toutes les dispositions relatives aux prestations et les règles administratives.",
    href: "/fr#plan-rules",
  },
  {
    title: "Portail membre",
    type: "Page",
    snippet: "Les membres peuvent utiliser le portail membre sécurisé pour accéder aux renseignements disponibles sur leur compte de retraite, y compris les relevés et autres ressources pour les membres. Consultez les renseignements sur votre compte de retraite, accédez aux relevés et utilisez l'accès libre-service sécurisé en ligne.",
    href: "/fr#member",
  },
  {
    title: "Accès au portail",
    type: "Page",
    snippet: "Le nom d'utilisateur est l'adresse courriel au dossier de la Caisse de retraite des musiciens du Canada. Première connexion ou mot de passe oublié : utilisez Mot de passe oublié sur le portail. Besoin d'aide? Communiquez avec le Bureau de la Caisse.",
    href: "/fr#member",
  },
  {
    title: "Nous joindre",
    type: "Page",
    snippet: "Communiquez avec le Bureau de la Caisse pour toute question concernant votre retraite, les cotisations, les prestations, l'accès au compte membre ou des renseignements généraux sur le régime. Situé au 200, boul. Yorkland, bureau 605, Toronto (Ontario) M2J 5C1. Téléphone : 416-497-4702. Sans frais : 1-888-462-6666. Courriel : info@mpfcanada.ca.",
    href: "/fr#contact",
  },
  {
    title: "Personnes-ressources du Bureau de la Caisse",
    type: "Page",
    snippet: "Communiquez directement avec la personne-ressource appropriée du Bureau de la Caisse : Paul Versteeg-Lytwyn (directeur général), Lisa DeWitt (gestionnaire du traitement des données), Humberto Martins (directeur des prestations de retraite), Nadia Chamale (traitement des contrats), Preesin Doorganah (adjoint, prestations de retraite), Thinn Soe (adjointe au directeur général), Wahida Hashem (réceptionniste).",
    href: "/fr#contact",
  },
  {
    title: "Heures de bureau",
    type: "Page",
    snippet: "Le Bureau de la Caisse est ouvert du lundi au vendredi, de 9 h à 16 h. Situé au 200, boul. Yorkland, bureau 605, Toronto (Ontario) M2J 5C1.",
    href: "/fr#contact",
  },

  // ── Ressources ──
  {
    title: "Ressources et documents",
    type: "Page",
    snippet: "Accédez aux documents du régime, aux formulaires, aux rapports et aux documents de référence de la Caisse de retraite des musiciens du Canada. Parcourez les catégories : rapports annuels, bulletins d'information, formulaires, Qu'arrive-t-il si?, et plus.",
    href: "/fr/resources",
  },
  {
    title: "Rapports annuels",
    type: "Resource",
    snippet: "Consultez les rapports annuels de la Caisse de 2013 à 2024. Chaque rapport comprend les états financiers, le rendement des placements et les mises à jour du régime de la Caisse de retraite des musiciens du Canada.",
    href: "/fr/resources?category=annual-reports",
  },
  {
    title: "Bulletins d'information",
    type: "Resource",
    snippet: "Parcourez les archives des bulletins d'information de la Caisse de 2003 à 2026. Les bulletins fournissent des mises à jour aux membres, des modifications du régime et des annonces importantes de la Caisse de retraite des musiciens du Canada.",
    href: "/fr/resources?category=newsletters",
  },
  {
    title: "Formulaires",
    type: "Resource",
    snippet: "Téléchargez et soumettez des formulaires pour les demandes de retraite, les désignations de bénéficiaire, les changements d'adresse et plus. Comprend le formulaire de changement de bénéficiaire, l'avis de changement d'adresse et la demande de formulaire de retraite.",
    href: "/fr/resources?category=forms",
  },
  {
    title: "Qu'arrive-t-il si?",
    type: "Resource",
    snippet: "Trouvez des réponses aux scénarios courants : demande de retraite après 71 ans, changement de bénéficiaire, invalidité, divorce, départ du milieu de la musique ou travail aux États-Unis.",
    href: "/fr/resources?category=what-happens-if",
  },
  {
    title: "Ce que vous devez savoir",
    type: "Resource",
    snippet: "Renseignements importants : dépôt de plaintes, inflation et retraite, mise à jour des coordonnées, exigences contractuelles pour les chefs, acquisition des droits, responsabilités des fiduciaires, cotisations, demande de prestation de retraite, modifications liées à la COVID-19 et cotisations non admissibles.",
    href: "/fr/resources?category=things-you-need-to-know",
  },
  {
    title: "Liens",
    type: "Resource",
    snippet: "Liens externes utiles, y compris la Fédération canadienne des musiciens et Services Canada pour des ressources supplémentaires sur les pensions et l'emploi.",
    href: "/fr/resources?category=links",
  },
  {
    title: "Comparaisons REER",
    type: "Resource",
    snippet: "Comparez les avantages du régime de la Caisse de retraite des musiciens du Canada avec l'épargne REER, aidant les membres à comprendre la valeur de leur retraite à prestations déterminées.",
    href: "/fr/resources?category=rrsp-comparisons",
  },
  {
    title: "Avis SOMEPP",
    type: "Resource",
    snippet: "L'avis du régime de retraite interentreprises déterminé de l'Ontario (SOMEPP) expliquant la désignation du régime et ce qu'elle signifie pour les prestations de retraite des membres et les exigences de financement.",
    href: "/fr/resources?category=somepp-notice",
  },
  {
    title: "Définitions clés du régime",
    type: "Resource",
    snippet: "Comprendre les définitions clés du régime, y compris l'emploi visé, la rémunération visée, le maximum des gains annuels ouvrant droit à pension, le service d'acquisition et d'autres termes importants du régime.",
    href: "/fr/resources?category=key-plan-definitions",
  },
  {
    title: "Glossaire des termes",
    type: "Resource",
    snippet: "Un glossaire complet des termes liés à la retraite et au régime pour aider les membres à comprendre le langage utilisé dans les documents et communications du régime.",
    href: "/fr/resources?category=key-plan-definitions",
  },

  // ── FAQ ──
  {
    title: "La Caisse et son fonctionnement",
    type: "FAQ",
    snippet: "Apprenez-en davantage sur le type de régime, comment adhérer, les critères d'admissibilité, ce que signifie FCM, comment devenir membre et les définitions clés du régime de la Caisse de retraite des musiciens du Canada.",
    href: "/fr/faq#the-fund-and-how-it-works",
  },
  {
    title: "Quel type de régime est la Caisse de retraite des musiciens du Canada?",
    type: "FAQ",
    snippet: "Le régime est un régime de retraite interentreprises à prestations déterminées, communément appelé régime à prestations cibles. Les prestations sont prédéterminées selon une formule basée sur les cotisations des employeurs. Les taux d'accumulation peuvent être ajustés selon l'état de capitalisation du régime.",
    href: "/fr/faq#the-fund-and-how-it-works",
  },
  {
    title: "Prestations de retraite",
    type: "FAQ",
    snippet: "Réponses sur les types de prestations versées par le régime, l'indexation des pensions, la retraite spéciale, la prestation d'invalidité, le calcul des prestations, la désignation du bénéficiaire, les garanties de pension, la retraite anticipée et le travail après la retraite.",
    href: "/fr/faq#pension-benefits",
  },
  {
    title: "Comment ma prestation est-elle calculée?",
    type: "FAQ",
    snippet: "Votre retraite est calculée en trois parties selon la période des cotisations : Partie 1 (avant 2011), Partie 2 (2011-2012) et Partie 3 (2013 et après). Chaque partie utilise des taux d'accumulation différents par tranche de 100 $ de cotisations versées en votre nom.",
    href: "/fr/faq#pension-benefits",
  },
  {
    title: "Puis-je prendre ma retraite avant 65 ans?",
    type: "FAQ",
    snippet: "Oui, vous pouvez prendre votre retraite dès l'âge de 55 ans si vous avez acquis des droits. Votre versement mensuel de retraite sera réduit selon votre âge au moment de la retraite — plus vous êtes jeune, plus la réduction est importante.",
    href: "/fr/faq#pension-benefits",
  },
  {
    title: "Prestations de décès",
    type: "FAQ",
    snippet: "Ce qui arrive à votre prestation de retraite si vous décédez avant ou après avoir commencé à recevoir votre prestation, y compris les prestations de décès avant la retraite et les prestations de survivant pour votre bénéficiaire.",
    href: "/fr/faq#death-benefits",
  },
  {
    title: "Renseignements sur les cotisations",
    type: "FAQ",
    snippet: "Comment les cotisations de retraite sont versées, si vous pouvez faire vos propres cotisations, les règles sur les cachets négociés, les limites de taux de cotisation, le travail à l'extérieur du Canada, les congés, la déclaration T4 et le travail pendant la retraite.",
    href: "/fr/faq#contribution-information",
  },
  {
    title: "Comment les cotisations de retraite sont-elles versées à la Caisse?",
    type: "FAQ",
    snippet: "Les cotisations de retraite sont versées en votre nom par vos employeurs selon vos dates d'emploi et vos salaires de la grille. Les cotisations sont détenues dans un fonds en fiducie pour fournir des prestations aux membres admissibles et à leurs bénéficiaires.",
    href: "/fr/faq#contribution-information",
  },
  {
    title: "Événements de la vie",
    type: "FAQ",
    snippet: "Que faire pour se préparer à la retraite, se marier ou divorcer pendant la retraite, et les calculs de rupture de mariage.",
    href: "/fr/faq#life-events",
  },
  {
    title: "Général",
    type: "FAQ",
    snippet: "Comment vérifier les renseignements de votre compte via le portail membre et comment les cotisations à la Caisse sont investies dans un portefeuille diversifié géré par des gestionnaires de placements professionnels.",
    href: "/fr/faq#general",
  },

  // ── Actualités ──
  {
    title: "Changements au conseil de fiduciaires",
    type: "News",
    snippet: "NOV 2025 — Eddy Bayens prend sa retraite du conseil après plus de 20 ans. Bernard LeBlanc nommé vice-président. David Owen accueilli comme nouveau fiduciaire employé.",
    href: "/fr/news",
  },
  {
    title: "Annonce du décès de Jill Giustino, directrice générale",
    type: "News",
    snippet: "JAN 2025 — Annonce officielle du décès de Jill Giustino, directrice générale de la Caisse de retraite des musiciens du Canada.",
    href: "/fr/news",
  },
  {
    title: "Pandémie de COVID-19 et volatilité des marchés financiers",
    type: "News",
    snippet: "AVR 2020 — Mise à jour officielle de la Caisse sur la COVID-19 traitant de l'impact de la pandémie sur les marchés financiers et le régime, avec questions et réponses pour les membres.",
    href: "/fr/news",
  },
  {
    title: "Mise à jour sur le projet de loi 34 du Québec",
    type: "News",
    snippet: "Mises à jour de 2015 et 2016 concernant le projet de loi 34 du Québec et son impact sur la Caisse de retraite des musiciens du Canada et les membres du régime basés au Québec.",
    href: "/fr/news",
  },
  {
    title: "Référendum de la GMMQ sur la désaffiliation",
    type: "News",
    snippet: "MAI 2014 — Réponse des fiduciaires au référendum de la Guilde des musiciens et musiciennes du Québec sur la désaffiliation de l'AFM, répondant aux préoccupations des membres concernant la participation continue au régime.",
    href: "/fr/news",
  },
];

export function searchContentFr(query: string): SearchEntry[] {
  if (!query || query.trim().length === 0) return [];

  const terms = query.toLowerCase().trim().split(/\s+/);

  return searchIndexFr
    .map((entry) => {
      const titleLower = entry.title.toLowerCase();
      const snippetLower = entry.snippet.toLowerCase();
      const typeLower = entry.type.toLowerCase();

      let score = 0;

      for (const term of terms) {
        if (titleLower === term) score += 10;
        else if (titleLower.includes(term)) score += 5;
        else if (new RegExp(`\\b${term}`).test(titleLower)) score += 3;
        if (snippetLower.includes(term)) score += 2;
        const typeMap: Record<string, string> = { "Page": "page", "Resource": "ressource", "FAQ": "faq", "News": "actualités" };
        if (typeMap[entry.type]?.includes(term)) score += 1;
      }

      return { entry, score };
    })
    .filter(({ score }) => score > 0)
    .sort((a, b) => b.score - a.score)
    .map(({ entry }) => entry);
}